import React from "react";
import {useLoaderData, useRouteLoaderData} from "react-router-dom";
import IncomingAttackList from "../../travian/ingameData/incomingAttacks/list";

export default function GroupIncomingAttacks({ }) {
    const { id } = useRouteLoaderData('group');
    /** @type object */
    const data = useLoaderData();
    return <IncomingAttackList data={Object.values(data)} groupId={id}></IncomingAttackList>
}
